// src/Dashboard/pages/user/Produits/components/VKardLink.jsx

import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";

import { DEVELOPER_PROFILE } from "../utils/productsUtils";

export default function VKardLink({
  url = DEVELOPER_PROFILE.vkard,
  logo = "https://media.licdn.com/dms/image/v2/D4E0BAQETJ3lAsk4sKA/company-logo_200_200/company-logo_200_200/0/1716333982627/vkard_io_logo?e=2147483647&v=beta&t=0mcqCmpMvHUPuoWJ5UFSid1as0YzDhH2ital1cterIg",
  label = "Ma VKard",
}) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      title="Ouvrir ma carte de visite VKard"
      className="inline-flex items-center gap-2 rounded-2xl bg-white px-3 py-2 text-sm font-bold text-slate-700 ring-1 ring-slate-200 transition hover:bg-slate-50 dark:bg-slate-800 dark:text-slate-200 dark:ring-slate-700 dark:hover:bg-slate-700"
    >
      <img
        src={logo}
        alt="VKard"
        className="h-8 w-8 rounded-lg object-contain"
        loading="lazy"
      />

      <span>{label}</span>

      <FaExternalLinkAlt className="text-xs opacity-70" />
    </a>
  );
}